export const PRIVACY_POLICY_URL = 'https://giftee.co.jp/privacypolicy/'
export const BULK_ORDER_TEWATASHI_FORM_URL =
  'https://form.run/@bulk-order-tewatashi'
export const BULK_ORDER_LP_URL = 'https://giftee.com/announcements/69'
export const FULFILLMENT_BULK_ORDER_LP_URL =
  'https://giftee.com/announcements/698'
